<template>
    <div
        :class="[
            `bg-draft border-draft text-draft-text text-sm`,
            'rounded-full inline-flex items-center px-[8px] leading-[14px] tracking-[0.2px] h-[24px] gap-x-[8px]',
        ]"
    >
        <PhFileDashed class="size-4" />
        <p v-text="$lang.get('Draft')" />
    </div>
</template>

<script>
import { PhFileDashed } from '@phosphor-icons/vue'
export default {
    name: 'DraftTag',

    components: {
        PhFileDashed,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
    },
}
</script>
